// extracted by mini-css-extract-plugin
export default {"serviceDiv":"service_item_serviceDiv__9qI8M","discriptionArea":"service_item_discriptionArea__9LCPf","active":"service_item_active__RfFAc","titleDiv":"service_item_titleDiv__mA-Fy"};